var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4052 0H4.95349C3.49926 0 2.31769 1.14827 2.31769 2.56151V3.4448H0.863453C0.386282 3.4448 0 3.82019 0 4.28391V5.18927C0 5.653 0.386282 6.02839 0.863453 6.02839H2.31769V9.18612H0.863453C0.386282 9.18612 0 9.56151 0 10.0252V10.9527C0 11.4164 0.386282 11.7918 0.863453 11.7918H2.31769V14.9495H0.863453C0.386282 14.9495 0 15.3249 0 15.7886V16.7161C0 17.1798 0.386282 17.5552 0.863453 17.5552H2.31769V18.4385C2.31769 19.8517 3.49926 21 4.95349 21H18.4052C19.8594 21 21.041 19.8517 21.041 18.4385V2.56151C21.041 1.14827 19.8594 0 18.4052 0ZM11.6793 4.68139C13.2017 4.68139 14.4515 5.8959 14.4515 7.37539C14.4515 8.85489 13.2017 10.0694 11.6793 10.0694C10.1569 10.0694 8.9072 8.85489 8.9072 7.37539C8.9072 5.87382 10.1569 4.68139 11.6793 4.68139ZM7.04396 15.082C7.04396 13.1388 7.68019 11.4385 8.97537 10.489C9.70249 11.0852 10.6568 11.4606 11.6793 11.4606C12.7018 11.4606 13.6562 11.0852 14.3833 10.489C15.6785 11.4606 16.3147 13.1609 16.3147 15.082C16.3147 16.5174 7.04396 16.5174 7.04396 15.082Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.24d874eda74c644f32e2edffab69aeb1.svg";
export { ForwardRef as ReactComponent };